// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;
module.exports.FcCheckmark = function FcCheckmark(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "version": "1",
      "viewBox": "0 0 48 48",
      "enableBackground": "new 0 0 48 48"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "fill": "#43A047",
        "points": "40.6,12.1 17,35.7 7.4,26.1 4.6,29 17,41.3 43.4,14.9"
      }
    }]
  })(props);
};